var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "award" }, [
    _vm._m(0),
    _c("div", { staticClass: "award__content" }, [
      _c("span", { staticClass: "award__content__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c("br"),
      _c("span", { staticClass: "award__content__year" }, [
        _vm._v(_vm._s(_vm.year))
      ])
    ]),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "award__asset" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "--small",
            "data-srcset": "/static/images/award_asset.png"
          }
        }),
        _c("source", {
          attrs: {
            media: "--large",
            "data-srcset": "/static/images/award_asset@2x.png"
          }
        }),
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            "data-sizes": "auto",
            "data-src": "/static/images/award_asset@2x.png"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "award__asset award__asset--reverse" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "--small",
            "data-srcset": "/static/images/award_asset.png"
          }
        }),
        _c("source", {
          attrs: {
            media: "--large",
            "data-srcset": "/static/images/award_asset@2x.png"
          }
        }),
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            "data-sizes": "auto",
            "data-src": "/static/images/award_asset@2x.png"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8fee61a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fee61a4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/awards/award-view.vue
// module id = 526
// module chunks = 89